import { isSameDay } from 'date-fns';
import { Habit } from 'shared/types/habit';
import { RepeatingTask } from 'shared/types/repeating-task';
import { Task } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';
import { getScheduleByDate } from 'shared/utils/schedules';

export const getSharedDateValue = (tasks: Task[]): Timestamp | undefined => {
  if (!tasks.length) {
    return undefined;
  }

  const firstTask = tasks[0];
  let firstValue = firstTask.endStrategy?.deadline;

  if (firstTask.schedules?.length) {
    const scheduledTask = firstTask as Habit | RepeatingTask;
    for (const schedule of scheduledTask.schedules) {
      const plannedOccurrences = schedule.plannedOccurrences ?? [];
      if (plannedOccurrences.length) {
        firstValue = plannedOccurrences[0].date;
        break;
      }
    }
  }

  if (!firstValue) {
    return;
  }

  for (const task of tasks) {
    if (task.schedules?.length) {
      const scheduledTask = task as Habit | RepeatingTask;
      const schedule = getScheduleByDate(scheduledTask.schedules, firstValue);
      const plannedOccurrence = schedule?.plannedOccurrences?.find((po) =>
        isSameDay(po.date, firstValue!),
      );

      if (
        !plannedOccurrence ||
        !isSameDay(plannedOccurrence.date, firstValue!)
      ) {
        return;
      }
      continue;
    }

    if (
      !task.endStrategy?.deadline ||
      !isSameDay(task.endStrategy.deadline, firstValue!)
    ) {
      return;
    }
  }

  return firstValue;
};
